import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export function FolderIcon(props: SvgIconProps) {
  return (
    <SvgIcon width='15' height='16' viewBox='0 0 640 640' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M128 512H512C547.3 512 576 483.3 576 448V208C576 172.7 547.3 144 512 144H362.7C355.8 144 349 141.8 343.5 137.6L305.1 108.8C294 100.5 280.5 96 266.7 96H128C92.7 96 64 124.7 64 160V448C64 483.3 92.7 512 128 512Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
}
